export default __webpack_public_path__ + "static/media/header.e5dacaab.png";